<template>
  <div v-if="item" class="word">
    <div class="mb-4 d-flex align-items-center">
      <h1 class="text-capitalize word-test mb-0">
        {{ item.word | deleteUnderscore }}
      </h1>
      <i class="fa fa-volume-up ml-2" @click="speak(item.word)"></i>
    </div>
    <small>{{ $t('dictionary.definition') }}</small>
    <hr class="mt-2 mb-3" />
    <span class="font-italic" style="color: #1a1a1a;">{{ item.ss_type | wordType }}</span>
    <p class="definition" style="color: #1a1a1a;">{{ item.definition }}</p>
  </div>
</template>
<script>
export default {
  name: 'WordItem',
  filters: {
    wordType(type) {
      if (type === 'v') {
        return 'Verb';
      }
      if (type === 'n') {
        return 'Noun';
      }
      if (type === 'a' || type === 's') {
        return 'Adjective';
      }
      if (type === 'r') {
        return 'Adverb';
      }
      return '';
    },
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    speak(text) {
      const msg = new SpeechSynthesisUtterance();
      msg.volume = 1;
      msg.rate = 1;
      msg.pitch = 1.5;
      msg.text = text;

      speechSynthesis.speak(msg);
    },
  },
};
</script>
<style lang="sass" scoped>
.word
  background-color: #fff
.word-test
  font-weight: 600
.definition
  line-height: 1.5
  margin-left: 1rem
  margin-top: .5rem
  &:first-letter
    text-transform: uppercase
.fa
  cursor: pointer

.fa-volume-up
  background-color: #2E9AB4
  color: #fff
  padding: .3em
  border-radius: 50%
</style>
